import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useTheme } from '../../hooks/useTheme.js';
import { IconButton } from '../../IconButton/IconButton.js';
import { useEditorContext } from '../EditorContext/EditorContext.js';

var EditorMenuButton = forwardRef(function (props, ref) {
    var children = props.children, commandName = props.commandName, label = props.label, onClickProp = props.onClick, styleProps = __rest(props, ["children", "commandName", "label", "onClick"]);
    var _a = useEditorContext(), editor = _a.editor, disabled = _a.disabled;
    var handleStyleProps = useTheme().handleStyleProps;
    var _b = handleStyleProps(styleProps, {
        themeKey: "editorMenuButton",
    }), css = _b.css, forwardProps = __rest(_b, ["css"]);
    var onClick = function (e) {
        if (disabled)
            return;
        onClickProp === null || onClickProp === void 0 ? void 0 : onClickProp(e);
    };
    return (jsx(IconButton, __assign({ "aria-disabled": disabled, "data-disabled": disabled, look: "naked", label: label, onClick: onClick, ref: ref, sx: css, type: "button", "data-is-active": !!(!disabled && commandName && editor.isActive(commandName)) }, forwardProps, { children: children })));
});

export { EditorMenuButton };
//# sourceMappingURL=EditorMenuButton.js.map
